// removed by extract-text-webpack-plugin
module.exports = {"header":"Header__header--3d1x-","content":"Header__content--1uOn_","mainText":"Header__mainText--2Kv10","subText":"Header__subText--2esen","subscribe":"Header__subscribe--19kIn","bounce":"Header__bounce--3CfVj"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Library/Header/Header.css
// module id = ./src/components/Library/Header/Header.css
// module chunks = 1